/**
 * LED Matrix Animator v3 — Vanilla JS for Shopify
 * Frame-by-frame animation editor for MAX7219 LED matrices
 *
 * Usage: <div class="led-matrix-animator"></div>
 */
(function(){
'use strict';

var mg=function(c,r){var g=[];for(var i=0;i<r;i++){g[i]=[];for(var j=0;j<c;j++)g[i][j]=0;}return g;};
var cg=function(g){return g.map(function(r){return r.slice();});};
var hx=function(b){return'0x'+('0'+b.toString(16).toUpperCase()).slice(-2);};

var LED={
  red:{on:'#ff1744',glow:'rgba(255,23,68,0.5)',dim:'#2a0a0a'},
  green:{on:'#00e676',glow:'rgba(0,230,118,0.5)',dim:'#0a1a0a'},
  blue:{on:'#448aff',glow:'rgba(68,138,255,0.5)',dim:'#0a0a1a'},
  white:{on:'#e0e0e0',glow:'rgba(224,224,224,0.4)',dim:'#1a1a1a'},
  amber:{on:'#ffab00',glow:'rgba(255,171,0,0.5)',dim:'#1a150a'}
};

/* ═══ FONTS (LSB=top) ═══ */
var F5={32:[5,0,0,0,0,0],33:[5,0,0,95,0,0],34:[5,0,7,0,7,0],35:[5,20,127,20,127,20],36:[5,36,42,127,42,18],37:[5,35,19,8,100,98],38:[5,54,73,85,34,80],39:[5,0,5,3,0,0],40:[5,0,28,34,65,0],41:[5,0,65,34,28,0],42:[5,20,8,62,8,20],43:[5,8,8,62,8,8],44:[5,0,80,48,0,0],45:[5,8,8,8,8,8],46:[5,0,96,96,0,0],47:[5,32,16,8,4,2],48:[5,62,81,73,69,62],49:[5,0,66,127,64,0],50:[5,66,97,81,73,70],51:[5,33,65,69,75,49],52:[5,24,20,18,127,16],53:[5,39,69,69,69,57],54:[5,60,74,73,73,48],55:[5,1,113,9,5,3],56:[5,54,73,73,73,54],57:[5,6,73,73,41,30],58:[5,0,54,54,0,0],59:[5,0,86,54,0,0],60:[5,8,20,34,65,0],61:[5,20,20,20,20,20],62:[5,0,65,34,20,8],63:[5,2,1,81,9,6],64:[5,62,65,93,85,30],65:[5,126,17,17,17,126],66:[5,127,73,73,73,54],67:[5,62,65,65,65,34],68:[5,127,65,65,34,28],69:[5,127,73,73,73,65],70:[5,127,9,9,9,1],71:[5,62,65,73,73,122],72:[5,127,8,8,8,127],73:[5,0,65,127,65,0],74:[5,32,64,65,63,1],75:[5,127,8,20,34,65],76:[5,127,64,64,64,64],77:[5,127,2,12,2,127],78:[5,127,4,8,16,127],79:[5,62,65,65,65,62],80:[5,127,9,9,9,6],81:[5,62,65,81,33,94],82:[5,127,9,25,41,70],83:[5,70,73,73,73,49],84:[5,1,1,127,1,1],85:[5,63,64,64,64,63],86:[5,31,32,64,32,31],87:[5,63,64,56,64,63],88:[5,99,20,8,20,99],89:[5,7,8,112,8,7],90:[5,97,81,73,69,67],91:[5,0,127,65,65,0],92:[5,2,4,8,16,32],93:[5,0,65,65,127,0],94:[5,4,2,1,2,4],95:[5,64,64,64,64,64],96:[5,0,1,2,4,0],97:[5,32,84,84,84,120],98:[5,127,72,68,68,56],99:[5,56,68,68,68,32],100:[5,56,68,68,72,127],101:[5,56,84,84,84,24],102:[5,8,126,9,1,2],103:[5,12,82,82,82,62],104:[5,127,8,4,4,120],105:[5,0,68,125,64,0],106:[5,32,64,68,61,0],107:[5,127,16,40,68,0],108:[5,0,65,127,64,0],109:[5,124,4,24,4,120],110:[5,124,8,4,4,120],111:[5,56,68,68,68,56],112:[5,124,20,20,20,8],113:[5,8,20,20,24,124],114:[5,124,8,4,4,8],115:[5,72,84,84,84,32],116:[5,4,63,68,64,32],117:[5,60,64,64,32,124],118:[5,28,32,64,32,28],119:[5,60,64,48,64,60],120:[5,68,40,16,40,68],121:[5,12,80,80,80,60],122:[5,68,100,84,76,68],123:[5,0,8,54,65,0],124:[5,0,0,127,0,0],125:[5,0,65,54,8,0],126:[5,16,8,8,16,8]};

var F3={32:[3,0,0,0],33:[1,23],34:[3,3,0,3],35:[3,31,10,31],36:[3,22,31,13],37:[3,25,4,19],38:[3,10,21,26],39:[1,3],40:[2,14,17],41:[2,17,14],42:[3,10,4,10],43:[3,4,14,4],44:[2,16,8],45:[3,4,4,4],46:[1,16],47:[3,24,4,3],48:[3,31,17,31],49:[3,18,31,16],50:[3,25,21,18],51:[3,17,21,31],52:[3,7,4,31],53:[3,23,21,13],54:[3,31,21,29],55:[3,1,25,7],56:[3,31,21,31],57:[3,23,21,31],58:[1,10],59:[2,16,10],60:[2,4,10],61:[3,10,10,10],62:[2,10,4],63:[3,1,21,2],64:[3,14,21,6],65:[3,30,5,30],66:[3,31,21,10],67:[3,14,17,17],68:[3,31,17,14],69:[3,31,21,17],70:[3,31,5,1],71:[3,14,17,29],72:[3,31,4,31],73:[3,17,31,17],74:[3,8,16,15],75:[3,31,4,27],76:[3,31,16,16],77:[3,31,2,31],78:[3,31,14,31],79:[3,14,17,14],80:[3,31,5,2],81:[3,14,25,30],82:[3,31,5,26],83:[3,18,21,9],84:[3,1,31,1],85:[3,15,16,15],86:[3,7,24,7],87:[3,31,8,31],88:[3,27,4,27],89:[3,3,28,3],90:[3,25,21,19],91:[2,31,17],92:[3,3,4,24],93:[2,17,31],94:[3,2,1,2],95:[3,16,16,16],96:[2,1,2],97:[3,8,20,28],98:[3,31,20,8],99:[3,12,18,18],100:[3,8,20,31],101:[3,12,26,20],102:[2,30,5],103:[3,20,42,30],104:[3,31,4,24],105:[1,29],106:[2,32,29],107:[3,31,8,20],108:[2,15,16],109:[3,28,8,28],110:[3,28,4,24],111:[3,12,18,12],112:[3,62,10,4],113:[3,4,10,62],114:[3,28,4,4],115:[3,20,30,10],116:[2,15,20],117:[3,12,16,28],118:[3,12,16,12],119:[3,28,16,28],120:[3,20,8,20],121:[3,6,40,30],122:[3,26,30,22],123:[2,4,27],124:[1,31],125:[2,27,4],126:[3,2,6,4]};

/* 8×8 Bold: center 5×7 + OR right neighbor */
var F8={};
(function(){var keys=Object.keys(F5);for(var ki=0;ki<keys.length;ki++){
  var k=+keys[ki],d=F5[k],w=d[0],cols=d.slice(1),bold=[],padL=Math.floor((8-w)/2),out=[0,0,0,0,0,0,0,0];
  for(var i=0;i<w;i++){var b=cols[i];if(i<w-1)b|=cols[i+1];bold.push(b);}
  for(var j=0;j<w;j++)out[padL+j]=bold[j];
  F8[k]=[8].concat(out);
}})();

var FONT_SETS={'3×5':F3,'5×7':F5,'8×8 Bold':F8};

function fontToGrid(data){
  var w=data[0],bytes=data.slice(1),g=mg(w,8);
  for(var c=0;c<w;c++)for(var r=0;r<8;r++)g[r][c]=(bytes[c]>>r)&1;
  return{cols:w,rows:8,grid:g};
}

/* ═══ PATTERNS ═══ */
var PATTERNS={
  'Checkerboard':function(c,r){var g=mg(c,r);for(var y=0;y<r;y++)for(var x=0;x<c;x++)g[y][x]=(x+y)%2;return g;},
  'Checker Inv':function(c,r){var g=mg(c,r);for(var y=0;y<r;y++)for(var x=0;x<c;x++)g[y][x]=(x+y+1)%2;return g;},
  'Border':function(c,r){var g=mg(c,r);for(var y=0;y<r;y++)for(var x=0;x<c;x++)g[y][x]=(y===0||y===r-1||x===0||x===c-1)?1:0;return g;},
  'Cross':function(c,r){var g=mg(c,r);var mx=Math.floor(c/2),my=Math.floor(r/2);for(var y=0;y<r;y++)g[y][mx]=1;for(var x=0;x<c;x++)g[my][x]=1;return g;},
  'X Diag':function(c,r){var g=mg(c,r);for(var i=0;i<r;i++){var x1=Math.round(i*(c-1)/(r-1)),x2=c-1-x1;if(x1>=0&&x1<c)g[i][x1]=1;if(x2>=0&&x2<c)g[i][x2]=1;}return g;},
  'H Lines':function(c,r){var g=mg(c,r);for(var y=0;y<r;y+=2)for(var x=0;x<c;x++)g[y][x]=1;return g;},
  'V Lines':function(c,r){var g=mg(c,r);for(var y=0;y<r;y++)for(var x=0;x<c;x+=2)g[y][x]=1;return g;},
  'Diamond':function(c,r){var g=mg(c,r);var cx=(c-1)/2,cy=(r-1)/2,sz=Math.min(Math.floor(c/2),Math.floor(r/2));
    for(var y=0;y<r;y++)for(var x=0;x<c;x++){if(Math.abs(Math.abs(x-cx)+Math.abs(y-cy)-sz)<0.6)g[y][x]=1;}return g;},
  'Heart':function(c,r){var g=mg(c,r);if(c<7||r<7)return g;var h=[[0,1,0,1,0],[1,1,1,1,1],[1,1,1,1,1],[0,1,1,1,0],[0,0,1,0,0]];
    var ox=Math.floor((c-5)/2),oy=Math.max(0,Math.floor((r-5)/2));for(var y=0;y<5&&y+oy<r;y++)for(var x=0;x<5&&x+ox<c;x++)g[y+oy][x+ox]=h[y][x]||0;return g;},
  'Smiley':function(c,r){var g=mg(c,r);if(c<8||r<8)return g;var s=[[0,0,1,1,1,1,0,0],[0,1,0,0,0,0,1,0],[1,0,1,0,0,1,0,1],[1,0,0,0,0,0,0,1],[1,0,1,0,0,1,0,1],[1,0,0,1,1,0,0,1],[0,1,0,0,0,0,1,0],[0,0,1,1,1,1,0,0]];
    var ox=Math.floor((c-8)/2),oy=Math.floor((r-8)/2);for(var y=0;y<8&&y+Math.max(0,oy)<r;y++)for(var x=0;x<8&&x+Math.max(0,ox)<c;x++)g[y+Math.max(0,oy)][x+Math.max(0,ox)]=s[y][x];return g;},
  'Arrow R':function(c,r){var g=mg(c,r);var my=Math.floor(r/2);for(var x=1;x<c-2;x++)g[my][x]=1;for(var i=0;i<Math.min(4,Math.floor(r/2)+1);i++){if(my-i>=0&&c-2-i>=0)g[my-i][c-2-i]=1;if(my+i<r&&c-2-i>=0)g[my+i][c-2-i]=1;}return g;},
  'Arrow L':function(c,r){var g=mg(c,r);var my=Math.floor(r/2);for(var x=2;x<c-1;x++)g[my][x]=1;for(var i=0;i<Math.min(4,Math.floor(r/2)+1);i++){if(my-i>=0&&1+i<c)g[my-i][1+i]=1;if(my+i<r&&1+i<c)g[my+i][1+i]=1;}return g;},
  'Fill':function(c,r){var g=mg(c,r);for(var y=0;y<r;y++)for(var x=0;x<c;x++)g[y][x]=1;return g;},
  'Random':function(c,r){var g=mg(c,r);for(var y=0;y<r;y++)for(var x=0;x<c;x++)g[y][x]=Math.random()>0.55?1:0;return g;}
};

function exportArduino(frames,cols,rows){
  var n=frames.length;
  var o='/**\n * LED Matrix Animation — '+cols+'×'+rows+' | '+n+' frames\n';
  var total=0;for(var ti=0;ti<n;ti++)total+=frames[ti].duration;
  o+=' * Total: '+total+'ms\n */\n\n';
  o+='#include <MD_MAX72xx.h>\n\n#define NUM_FRAMES '+n+'\n#define FRAME_COLS '+cols+'\n\n';
  o+='const uint8_t PROGMEM frames[NUM_FRAMES][FRAME_COLS] = {\n';
  for(var fi=0;fi<n;fi++){
    var f=frames[fi],bytes=[];
    for(var c=0;c<cols;c++){var b=0;for(var r=0;r<rows;r++)if(f.grid[r][c])b|=1<<(rows-1-r);bytes.push(b);}
    o+='  {'+bytes.map(hx).join(', ')+'}'+(fi<n-1?',':'')+' // Frame '+fi+' ('+f.duration+'ms)\n';
  }
  o+='};\n\nconst uint16_t frameDurations[NUM_FRAMES] = {'+frames.map(function(f){return f.duration;}).join(', ')+'};\n\n';
  o+='void playAnimation(MD_MAX72XX &mx) {\n  for (int f = 0; f < NUM_FRAMES; f++) {\n';
  o+='    for (int c = 0; c < FRAME_COLS; c++)\n      mx.setColumn(c, pgm_read_byte(&frames[f][c]));\n';
  o+='    delay(frameDurations[f]);\n  }\n}\n';
  return o;
}

/* ═══ MAIN INIT ═══ */
function initAnimator(root){
  var cols=8,rows=8;
  var frames=[{grid:mg(8,8),duration:200}];
  var activeFrame=0,painting=false,paintVal=1;
  var undoStack=[],maxUndo=30;
  var ledColor='red',onionSkin=false;
  var playing=false,playTimer=null;
  var selectedFont='5×7',stampChar='A',stampX=0;
  var theme=localStorage.getItem('lma-theme')||'light';
  var CHARS='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#%&*+-=?/';

  function cur(){return frames[activeFrame];}
  function pushUndo(){undoStack.push({fi:activeFrame,grid:cg(cur().grid)});if(undoStack.length>maxUndo)undoStack.shift();}

  /* ═══ BUILD HTML ═══ */
  root.innerHTML='<div class="lma-wrap'+(theme==='dark'?' lma-dark':'')+'">'+
    '<div class="lma-header"><div class="lma-header-left"><span class="lma-logo">&#9654; LED MATRIX ANIMATOR</span><span class="lma-sub">Frame-by-frame for MAX7219</span></div>'+
    '<div class="lma-header-right"><button class="lma-btn" id="lma-theme">'+(theme==='dark'?'&#9788; Light':'&#9790; Dark')+'</button><span class="lma-sep">│</span>'+
    '<button class="lma-btn lma-accent" id="lma-new">&#10010; New</button><button class="lma-btn" id="lma-undo">↶ Undo</button></div></div>'+
    '<div class="lma-main"><div class="lma-controls" id="lma-controls"></div>'+
    '<div class="lma-grid-preview"><div class="lma-grid-box"><div class="lma-grid" id="lma-grid"></div>'+
    '<div class="lma-grid-info" id="lma-grid-info"></div></div>'+
    '<div class="lma-prev-col"><div class="lma-label">LED Preview</div>'+
    '<div class="lma-prev-box"><div class="lma-preview" id="lma-preview"></div></div></div></div>'+
    '<div class="lma-tools" id="lma-tools"></div>'+
    '<div class="lma-patterns-panel"><div class="lma-panel-title">Patterns — click to apply to current frame</div>'+
    '<div class="lma-patterns" id="lma-patterns"></div></div>'+
    '<div class="lma-stamp-panel"><div class="lma-panel-title">Stamp character onto current frame</div>'+
    '<div class="lma-stamp-controls" id="lma-stamp-controls"></div>'+
    '<div class="lma-stamp-body"><div class="lma-stamp-preview" id="lma-stamp-preview"></div>'+
    '<div class="lma-char-palette" id="lma-char-palette"></div></div></div></div>'+
    '<div class="lma-timeline-section"><div class="lma-timeline-head" id="lma-timeline-head"></div>'+
    '<div class="lma-timeline" id="lma-timeline"></div></div>'+
    '<div class="lma-output-section"><div class="lma-output-head"><span>Arduino Code (Column-major, MSB=top)</span>'+
    '<button class="lma-btn lma-sm" id="lma-cp-code">Copy</button></div>'+
    '<pre class="lma-output" id="lma-output"></pre></div>'+
    '<div class="lma-toast" id="lma-toast" style="display:none"></div></div>';

  var gridEl=root.querySelector('#lma-grid'),prevEl=root.querySelector('#lma-preview');

  /* ═══ RENDER ═══ */
  function renderControls(){
    var h='<label class="lma-ctrl">W <input type="number" id="lma-w" value="'+cols+'" min="1" max="32"></label>';
    h+='<label class="lma-ctrl">H <input type="number" id="lma-h" value="'+rows+'" min="1" max="8"></label>';
    h+='<select id="lma-size"><option value="">Size…</option><option value="8x8">8×8</option><option value="16x8">16×8</option><option value="24x8">24×8</option><option value="32x8">32×8</option></select>';
    h+='<span class="lma-sep">│</span>';
    h+='<span class="lma-led-picker" id="lma-leds"></span>';
    h+='<span class="lma-sep">│</span>';
    h+='<label class="lma-check"><input type="checkbox" id="lma-onion"'+(onionSkin?' checked':'')+'>Onion</label>';
    root.querySelector('#lma-controls').innerHTML=h;
    renderLeds();
    root.querySelector('#lma-w').addEventListener('change',function(){resizeAll(Math.max(1,Math.min(32,+this.value||8)),rows);});
    root.querySelector('#lma-h').addEventListener('change',function(){resizeAll(cols,Math.max(1,Math.min(8,+this.value||8)));});
    root.querySelector('#lma-size').addEventListener('change',function(){if(!this.value)return;var p=this.value.split('x');resizeAll(+p[0],+p[1]);this.value='';});
    root.querySelector('#lma-onion').addEventListener('change',function(){onionSkin=this.checked;renderGrid();});
  }

  function renderLeds(){
    var h='';
    Object.keys(LED).forEach(function(k){
      h+='<div class="lma-led-dot'+(ledColor===k?' active':'')+'" data-color="'+k+'" style="background:'+LED[k].on+'"></div>';
    });
    var container=root.querySelector('#lma-leds');
    if(container)container.innerHTML=h;
    root.querySelectorAll('.lma-led-dot').forEach(function(el){
      el.addEventListener('click',function(){ledColor=this.dataset.color;renderLeds();renderPreview();});
    });
  }

  function renderGrid(){
    var s=cur(),sz=Math.max(12,Math.min(28,Math.floor(440/Math.max(cols,8))));
    gridEl.style.gridTemplateColumns='repeat('+cols+','+sz+'px)';
    gridEl.style.gridTemplateRows='repeat('+rows+','+sz+'px)';
    gridEl.innerHTML='';
    var prevGrid=activeFrame>0?frames[activeFrame-1].grid:null;
    for(var r=0;r<rows;r++)for(var c=0;c<cols;c++){
      var cell=document.createElement('div');
      var val=s.grid[r][c];
      var ghost=onionSkin&&prevGrid&&prevGrid[r]?prevGrid[r][c]:0;
      cell.className='lma-cell'+(val?' on':'')+(ghost&&!val?' ghost':'');
      cell.dataset.r=r;cell.dataset.c=c;
      cell.style.width=sz+'px';cell.style.height=sz+'px';
      gridEl.appendChild(cell);
    }
    var pixelCount=0;for(var r2=0;r2<rows;r2++)for(var c2=0;c2<cols;c2++)if(s.grid[r2][c2])pixelCount++;
    root.querySelector('#lma-grid-info').innerHTML='<span>'+pixelCount+'px</span><span>Frame '+(activeFrame+1)+'/'+frames.length+'</span>';
  }

  function renderPreview(){
    var s=cur(),lc=LED[ledColor];
    var sz=Math.max(12,Math.min(28,Math.floor(440/Math.max(cols,8))));
    var dotSz=Math.max(4,sz-4);
    prevEl.style.gridTemplateColumns='repeat('+cols+','+sz+'px)';
    prevEl.style.gridTemplateRows='repeat('+rows+','+sz+'px)';
    prevEl.innerHTML='';
    for(var r=0;r<rows;r++)for(var c=0;c<cols;c++){
      var wrap=document.createElement('div');
      wrap.style.cssText='width:'+sz+'px;height:'+sz+'px;display:flex;align-items:center;justify-content:center';
      var dot=document.createElement('div');
      dot.style.width=dotSz+'px';dot.style.height=dotSz+'px';dot.style.borderRadius='50%';
      if(s.grid[r][c]){dot.style.background=lc.on;dot.style.boxShadow='0 0 '+dotSz*0.5+'px '+lc.on+', 0 0 '+dotSz+'px '+lc.glow;}
      else{dot.style.background=lc.dim;}
      wrap.appendChild(dot);prevEl.appendChild(wrap);
    }
  }

  function renderTools(){
    var h='<button class="lma-btn lma-sm" id="lma-clear">Clear</button><button class="lma-btn lma-sm" id="lma-invert">Invert</button>';
    h+='<span class="lma-sep">│</span>';
    h+='<button class="lma-btn lma-sm" id="lma-sL">◀</button><button class="lma-btn lma-sm" id="lma-sR">▶</button>';
    h+='<button class="lma-btn lma-sm" id="lma-sU">▲</button><button class="lma-btn lma-sm" id="lma-sD">▼</button>';
    root.querySelector('#lma-tools').innerHTML=h;
    root.querySelector('#lma-clear').addEventListener('click',function(){pushUndo();cur().grid=mg(cols,rows);renderGrid();renderPreview();renderOutput();});
    root.querySelector('#lma-invert').addEventListener('click',function(){pushUndo();var s=cur();for(var r=0;r<rows;r++)for(var c=0;c<cols;c++)s.grid[r][c]=s.grid[r][c]?0:1;renderGrid();renderPreview();renderOutput();});
    root.querySelector('#lma-sL').addEventListener('click',function(){doShift('l');});
    root.querySelector('#lma-sR').addEventListener('click',function(){doShift('r');});
    root.querySelector('#lma-sU').addEventListener('click',function(){doShift('u');});
    root.querySelector('#lma-sD').addEventListener('click',function(){doShift('d');});
  }

  function renderPatterns(){
    var h='';
    Object.keys(PATTERNS).forEach(function(name){h+='<button class="lma-btn lma-sm" data-pattern="'+name+'">'+name+'</button>';});
    root.querySelector('#lma-patterns').innerHTML=h;
    root.querySelectorAll('[data-pattern]').forEach(function(btn){
      btn.addEventListener('click',function(){pushUndo();cur().grid=PATTERNS[this.dataset.pattern](cols,rows);renderGrid();renderPreview();renderOutput();});
    });
  }

  function renderStampControls(){
    var h='<label class="lma-ctrl">Font <select id="lma-font">';
    Object.keys(FONT_SETS).forEach(function(f){h+='<option value="'+f+'"'+(f===selectedFont?' selected':'')+'>'+f+'</option>';});
    h+='</select></label>';
    h+='<label class="lma-ctrl">Char <input type="text" id="lma-stamp-char" value="'+stampChar+'" maxlength="1" style="width:28px;text-align:center;font-size:13px"></label>';
    h+='<label class="lma-ctrl">X <input type="number" id="lma-stamp-x" value="'+stampX+'" min="0" max="'+(cols-1)+'" style="width:38px;text-align:center"></label>';
    h+='<button class="lma-btn lma-sm lma-accent" id="lma-stamp-go">Stamp ↓</button>';
    root.querySelector('#lma-stamp-controls').innerHTML=h;
    root.querySelector('#lma-font').addEventListener('change',function(){selectedFont=this.value;renderStampPreview();});
    root.querySelector('#lma-stamp-char').addEventListener('input',function(){stampChar=this.value.slice(-1)||'A';renderStampPreview();renderCharPalette();});
    root.querySelector('#lma-stamp-x').addEventListener('change',function(){stampX=Math.max(0,+this.value||0);});
    root.querySelector('#lma-stamp-go').addEventListener('click',doStamp);
  }

  function renderStampPreview(){
    var fontData=FONT_SETS[selectedFont];
    var code=stampChar.charCodeAt(0);
    var d=fontData[code];
    var el=root.querySelector('#lma-stamp-preview');
    if(!d){el.innerHTML='';return;}
    var info=fontToGrid(d);
    var lc=LED[ledColor];
    var h='<div style="display:grid;grid-template-columns:repeat('+info.cols+',4px);grid-template-rows:repeat(8,4px);gap:1px">';
    for(var r=0;r<8;r++)for(var c=0;c<info.cols;c++){
      h+='<div style="width:4px;height:4px;background:'+(info.grid[r][c]?lc.on:'#1a1a1a')+'"></div>';
    }
    h+='</div>';
    el.innerHTML=h;
  }

  function renderCharPalette(){
    var h='';
    for(var i=0;i<CHARS.length;i++){
      var ch=CHARS[i];
      h+='<div class="lma-char-btn'+(ch===stampChar?' active':'')+'" data-ch="'+ch+'">'+ch+'</div>';
    }
    root.querySelector('#lma-char-palette').innerHTML=h;
    root.querySelectorAll('.lma-char-btn').forEach(function(el){
      el.addEventListener('click',function(){stampChar=this.dataset.ch;
        var inp=root.querySelector('#lma-stamp-char');if(inp)inp.value=stampChar;
        renderStampPreview();renderCharPalette();});
    });
  }

  function renderTimeline(){
    var totalDur=0;for(var i=0;i<frames.length;i++)totalDur+=frames[i].duration;
    var headH='<div class="lma-tl-left"><span class="lma-label">Timeline</span>';
    headH+='<button class="lma-btn lma-sm lma-accent" id="lma-play">'+(playing?'⏹ Stop':'▶ Play')+'</button>';
    headH+='<span class="lma-tl-info">'+frames.length+' frames · '+totalDur+'ms</span></div>';
    headH+='<div class="lma-tl-right"><button class="lma-btn lma-sm" id="lma-add-frame">+ Frame</button>';
    headH+='<button class="lma-btn lma-sm" id="lma-dup-frame">Duplicate</button></div>';
    root.querySelector('#lma-timeline-head').innerHTML=headH;
    root.querySelector('#lma-play').addEventListener('click',togglePlay);
    root.querySelector('#lma-add-frame').addEventListener('click',function(){frames.push({grid:mg(cols,rows),duration:cur().duration});activeFrame=frames.length-1;renderAll();});
    root.querySelector('#lma-dup-frame').addEventListener('click',function(){frames.push({grid:cg(cur().grid),duration:cur().duration});activeFrame=frames.length-1;renderAll();});

    var tl=root.querySelector('#lma-timeline');tl.innerHTML='';
    var thumbSz=3;
    for(var fi=0;fi<frames.length;fi++){
      var f=frames[fi],isA=fi===activeFrame;
      var card=document.createElement('div');
      card.className='lma-frame-card'+(isA?' active':'');
      card.dataset.fi=fi;
      var gridH='<div class="lma-frame-thumb" style="grid-template-columns:repeat('+cols+','+thumbSz+'px);grid-template-rows:repeat('+rows+','+thumbSz+'px)">';
      for(var r=0;r<rows;r++)for(var c=0;c<cols;c++){
        gridH+='<div style="width:'+thumbSz+'px;height:'+thumbSz+'px;background:'+(f.grid[r][c]?(isA?LED[ledColor].on:'#888'):'#0a0a15')+'"></div>';
      }
      gridH+='</div>';
      card.innerHTML=gridH+'<div class="lma-frame-dur"><input type="number" value="'+f.duration+'" min="10" max="5000" step="10" data-fi="'+fi+'"><span>ms</span></div>'+
        '<div class="lma-frame-btns"><span class="lma-fbtn" data-mv="-1" data-fi="'+fi+'">◀</span><span class="lma-fbtn" data-mv="1" data-fi="'+fi+'">▶</span>'+
        (frames.length>1?'<span class="lma-fbtn lma-fdel" data-del="'+fi+'">✕</span>':'')+'</div>';
      tl.appendChild(card);
    }
    tl.querySelectorAll('.lma-frame-card').forEach(function(card){
      card.addEventListener('click',function(e){if(e.target.tagName==='INPUT'||e.target.classList.contains('lma-fbtn'))return;
        activeFrame=+this.dataset.fi;if(playing)stopPlay();renderAll();});
    });
    tl.querySelectorAll('.lma-frame-dur input').forEach(function(inp){
      inp.addEventListener('change',function(){frames[+this.dataset.fi].duration=Math.max(10,+this.value||200);renderTimeline();renderOutput();});
      inp.addEventListener('click',function(e){e.stopPropagation();});
    });
    tl.querySelectorAll('[data-mv]').forEach(function(btn){
      btn.addEventListener('click',function(e){e.stopPropagation();var fi=+this.dataset.fi,dir=+this.dataset.mv,ni=fi+dir;
        if(ni<0||ni>=frames.length)return;var tmp=frames[fi];frames[fi]=frames[ni];frames[ni]=tmp;activeFrame=ni;renderAll();});
    });
    tl.querySelectorAll('[data-del]').forEach(function(btn){
      btn.addEventListener('click',function(e){e.stopPropagation();if(frames.length<=1)return;
        var fi=+this.dataset.del;frames.splice(fi,1);if(activeFrame>=frames.length)activeFrame=frames.length-1;renderAll();});
    });
  }

  function renderOutput(){
    root.querySelector('#lma-output').textContent=exportArduino(frames,cols,rows);
  }

  function renderAll(){renderControls();renderTools();renderPatterns();renderStampControls();renderStampPreview();renderCharPalette();renderGrid();renderPreview();renderTimeline();renderOutput();}

  /* ═══ ACTIONS ═══ */
  function doShift(dir){
    pushUndo();var s=cur(),g=s.grid;
    if(dir==='l')for(var r=0;r<rows;r++){g[r].shift();g[r].push(0);}
    else if(dir==='r')for(var r2=0;r2<rows;r2++){g[r2].pop();g[r2].unshift(0);}
    else if(dir==='u'){g.shift();g.push(new Array(cols).fill(0));}
    else{g.pop();g.unshift(new Array(cols).fill(0));}
    renderGrid();renderPreview();renderOutput();
  }

  function doStamp(){
    var fontData=FONT_SETS[selectedFont];var code=stampChar.charCodeAt(0);var d=fontData[code];if(!d)return;
    pushUndo();var info=fontToGrid(d);var s=cur();
    for(var r=0;r<Math.min(8,rows);r++)for(var c=0;c<info.cols&&c+stampX<cols;c++)if(info.grid[r][c])s.grid[r][c+stampX]=1;
    renderGrid();renderPreview();renderOutput();
  }

  function resizeAll(nc,nr){
    for(var fi=0;fi<frames.length;fi++){
      var f=frames[fi],old=f.grid,g=mg(nc,nr);
      for(var r=0;r<Math.min(nr,rows);r++)for(var c=0;c<Math.min(nc,cols);c++)g[r][c]=old[r]?old[r][c]||0:0;
      f.grid=g;
    }
    cols=nc;rows=nr;renderAll();
  }

  function togglePlay(){if(playing)stopPlay();else startPlay();}
  function startPlay(){playing=true;playTimer=setInterval(function(){activeFrame=(activeFrame+1)%frames.length;renderGrid();renderPreview();renderTimeline();},cur().duration);renderTimeline();}
  function stopPlay(){playing=false;if(playTimer)clearInterval(playTimer);playTimer=null;renderTimeline();}

  function resetAll(){
    stopPlay();cols=8;rows=8;frames=[{grid:mg(8,8),duration:200}];activeFrame=0;undoStack=[];renderAll();
  }

  function copyText(text,btn){
    if(navigator.clipboard&&navigator.clipboard.writeText){navigator.clipboard.writeText(text).then(function(){flashBtn(btn);});}
    else{var ta=document.createElement('textarea');ta.value=text;ta.style.cssText='position:fixed;opacity:0';document.body.appendChild(ta);ta.select();document.execCommand('copy');document.body.removeChild(ta);flashBtn(btn);}
  }
  function flashBtn(btn){var orig=btn.textContent;btn.textContent='Copied!';btn.classList.add('lma-copied');setTimeout(function(){btn.textContent=orig;btn.classList.remove('lma-copied');},1500);}

  /* ═══ EVENTS ═══ */
  gridEl.addEventListener('mousedown',function(e){var el=e.target;if(!el.classList.contains('lma-cell'))return;e.preventDefault();
    pushUndo();var r=+el.dataset.r,c=+el.dataset.c;paintVal=cur().grid[r][c]?0:1;painting=true;
    cur().grid[r][c]=paintVal;renderGrid();renderPreview();renderOutput();});
  gridEl.addEventListener('mousemove',function(e){if(!painting)return;var el=e.target;if(!el.classList.contains('lma-cell'))return;
    cur().grid[+el.dataset.r][+el.dataset.c]=paintVal;renderGrid();renderPreview();renderOutput();});
  document.addEventListener('mouseup',function(){painting=false;});
  gridEl.addEventListener('touchstart',function(e){e.preventDefault();var t=e.touches[0],el=document.elementFromPoint(t.clientX,t.clientY);
    if(!el||!el.classList.contains('lma-cell'))return;pushUndo();paintVal=cur().grid[+el.dataset.r][+el.dataset.c]?0:1;painting=true;
    cur().grid[+el.dataset.r][+el.dataset.c]=paintVal;renderGrid();renderPreview();renderOutput();},{passive:false});
  gridEl.addEventListener('touchmove',function(e){e.preventDefault();if(!painting)return;var t=e.touches[0],el=document.elementFromPoint(t.clientX,t.clientY);
    if(!el||!el.classList.contains('lma-cell'))return;cur().grid[+el.dataset.r][+el.dataset.c]=paintVal;renderGrid();renderPreview();renderOutput();},{passive:false});
  gridEl.addEventListener('touchend',function(){painting=false;});

  root.querySelector('#lma-theme').addEventListener('click',function(){
    theme=theme==='dark'?'light':'dark';localStorage.setItem('lma-theme',theme);
    var wrap=root.querySelector('.lma-wrap');if(theme==='dark')wrap.classList.add('lma-dark');else wrap.classList.remove('lma-dark');
    this.innerHTML=theme==='dark'?'&#9788; Light':'&#9790; Dark';});
  root.querySelector('#lma-new').addEventListener('click',resetAll);
  root.querySelector('#lma-undo').addEventListener('click',function(){
    if(!undoStack.length)return;var s=undoStack.pop();frames[s.fi].grid=s.grid;activeFrame=s.fi;renderAll();});
  root.querySelector('#lma-cp-code').addEventListener('click',function(){copyText(root.querySelector('#lma-output').textContent,this);});

  document.addEventListener('keydown',function(e){if(e.target.tagName==='INPUT'||e.target.tagName==='TEXTAREA')return;
    if((e.ctrlKey||e.metaKey)&&e.key==='z'){e.preventDefault();root.querySelector('#lma-undo').click();}});

  renderAll();
}

/* ═══ AUTO-INIT ═══ */
function autoInit(){
  document.querySelectorAll('.led-matrix-animator').forEach(function(el){
    if(el.dataset.lmaInit)return;el.dataset.lmaInit='1';initAnimator(el);
  });
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){setTimeout(autoInit,50);});}
else{setTimeout(autoInit,50);}
})();
